// import Image from 'next/image';
// import React, { useState } from 'react';
// import { CSVDownload, CSVLink } from 'react-csv';
// import { useQuery } from 'react-query';
// import { viewVendorStats } from '../../../../api-client/my-product';
// import { deleteIcon, numberSales } from '../../../../assets/icons';
// import {
//   clicks,
//   number,
//   pending,
//   totalSales,
//   transfer,
// } from '../../../../public/assets/icons';
// import { capitalize } from '../../../../utils/formatters';
// import Button from '../../../elements/button';
// import Card from '../../../elements/card';
// import TabGroup from '../../../elements/tab/tab-group';
// import PageLoader from '../../page-loader';
// import PriceQty from '../../price-qty-card';
// import { PriceQtyCarouselQuo } from '../../price-qty-carousel';
// import StatsTable, { CustomerListTable, VendorListTable } from './table';

// const ViewStatsModal = ({ setViewStats, productToken }) => {
//   const {
//     data: stats,
//     isLoading,
//     status,
//   } = useQuery(['vendor-stats', productToken], () =>
//     viewVendorStats({ productToken: Number(productToken) })
//   );

//   const [selectedInput, setSelectedInput] = useState('');
//   const [activeTab, setActiveTab] = useState('affiliate list');
//   const handleChange = inputValue => {
//     setSelectedInput(inputValue);
//   };


//   const sliderItems = React.useMemo(() => {
//     return [
//       {
//         icon: clicks,
//         price:
//           status === 'error' ? 0 : stats?.data?.data?.salesSummary?.totalSales,
//         title: 'Afiliate clicks',
//       },
//       {
//         icon: numberSales,
//         price:
//           (status === status) === 'error'
//             ? '$0'
//             : `$${stats?.data?.data?.salesSummary?.totalAmountOfSales.toLocaleString()}`,
//         title: 'Amount of Sales',
//       },
//       {
//         icon: pending,
//         price:
//           status === 'error'
//             ? '$0'
//             : `$${stats?.data?.data?.salesSummary?.totalPendingPayment.toLocaleString()}`,
//         title: 'Amount of Pending Sales',
//       },
//       {
//         icon: number,
//         price:
//           status === 'error' ? 0 : stats?.data?.data?.salesSummary?.pageViews,
//         title: 'Number of Page Views',
//       },
//       {
//         icon: transfer,
//         price:
//           status === 'error'
//             ? '0%'
//             : `${stats?.data?.data?.salesSummary?.totalConversion}%`,
//         title: 'Total Conversion',
//       },
//       {
//         icon: totalSales,
//         price:
//           status === 'error'
//             ? '$0'
//             : `$${stats?.data?.data?.salesSummary.todaySales.toLocaleString()}`,
//         title: 'Today Sales',
//       },
//     ];
//   }, [stats]);

//   const renderTable = data => {
//     switch (data) {
//       case 'vendor list':
//         return (
//           <VendorListTable
//             stats={status === 'error' ? [] : stats?.data?.data?.affiliates}
//           />
//         );
//       case 'customer list':
//         return (
//           <CustomerListTable
//             stats={status === 'error' ? [] : stats?.data?.data?.getCustomers}
//           />
//         );
//       default:
//         return (
//           <VendorListTable
//             stats={status === 'error' ? [] : stats?.data?.data?.affiliates}
//           />
//         );
//     }
//   };
//   return (
//     <section className="h-full w-screen z-50 bg-black flex items-center justify-center fixed top-0 left-0 bg-opacity-40 ">
//       <Card className="w-[1080px]">
//         <div
//           className="flex justify-end items-end mb-10"
//           onClick={() => setViewStats(false)}
//         >
//           <button>
//             <Image src={deleteIcon} alt="Stakecut" />
//           </button>
//         </div>
//         <h2 className="text-md font-medium">
//           {stats && capitalize(stats?.data?.data?.salesSummary?.productName)}
//         </h2>
//         {status === 'error' ? (
//           <div className="bg-info text-blac px-6 w-full py-3">
//             Sorry This Product has not been sold yet
//           </div>
//         ) : null}
//         <div className="mt-4">
//           <PriceQtyCarouselQuo data={sliderItems} />
//         </div>
//         <div className="hidden lg:grid grid-cols-3 gap-2 py-4 items-center">
//           {isLoading ? (
//             <div className="animate-pulse h-48 rounded-2xl mb-2 w-64 my-2 bg-slate-100"></div>
//           ) : (
//             <PriceQty
//               price={
//                 status === 'error'
//                   ? 0
//                   : stats?.data?.data?.salesSummary?.totalSales
//               }
//               shadow="shadow"
//               icon={clicks}
//               title="Total Number of Sales"
//             />
//           )}

//           {isLoading ? (
//             <div className="animate-pulse h-48 rounded-2xl mb-2 w-64 my-2 bg-slate-100"></div>
//           ) : (
//             <PriceQty
//               price={
//                 status === 'error'
//                   ? '$0'
//                   : `$${stats?.data?.data?.salesSummary?.totalAmountOfSales.toLocaleString()}`
//               }
//               shadow="shadow"
//               icon={numberSales}
//               title="Amount of Sales"
//             />
//           )}
//           {isLoading ? (
//             <div className="animate-pulse h-48 rounded-2xl mb-2 w-64 my-2 bg-slate-100"></div>
//           ) : (
//             <PriceQty
//               price={
//                 status === 'error'
//                   ? '$0'
//                   : `$${stats?.data?.data?.salesSummary?.totalPendingPayment.toLocaleString()}`
//               }
//               shadow="shadow"
//               icon={pending}
//               title="Amount of Pending Sales"
//             />
//           )}
//           {isLoading ? (
//             <div className="animate-pulse h-48 rounded-2xl mb-2 w-64 my-2 bg-slate-100"></div>
//           ) : (
//             <PriceQty
//               price={
//                 status === 'error'
//                   ? 0
//                   : stats?.data?.data?.salesSummary?.pageViews
//               }
//               shadow="shadow"
//               icon={number}
//               title="Number of Page Views"
//             />
//           )}
//           {isLoading ? (
//             <div className="animate-pulse h-48 rounded-2xl mb-2 w-64 my-2 bg-slate-100"></div>
//           ) : (
//             <PriceQty
//               price={
//                 status === 'error'
//                   ? '0%'
//                   : `${stats?.data?.data?.salesSummary?.totalConversion}%`
//               }
//               shadow="shadow"
//               icon={transfer}
//               title="Total Conversion"
//             />
//           )}
//           {isLoading ? (
//             <div className="animate-pulse h-48 rounded-2xl mb-2 w-64 my-2 bg-slate-100"></div>
//           ) : (
//             <PriceQty
//               price={
//                 status === 'error'
//                   ? '$0'
//                   : `$${stats?.data?.data?.salesSummary.todaySales.toLocaleString()}`
//               }
//               shadow="shadow"
//               icon={totalSales}
//               title="Today Sales"
//             />
//           )}
//         </div>

//         <div className="grid grid-cols-2 items-center w-full mt-6">
//           <div className="col-span-2">
//             <TabGroup
//               active={activeTab}
//               setActive={setActiveTab}
//               data={[
//                 {
//                   id: 1,
//                   name: 'Affiliate List',
//                 },
//                 {
//                   id: 2,
//                   name: 'Customer List',
//                 },
//               ]}
//             />
//           </div>
//           <div className="w-full ml-6 col-span-1"></div>
//         </div>
//         {isLoading ? (
//           <div className="flex items-center justify-center ">
//             <PageLoader
//               loadingText="Loading Products, Please Wait... 😇 "
//               className="h-96 w-full"
//             />
//           </div>
//         ) : (
//           <div>{renderTable(activeTab)}</div>
//         )}

//         <div>
//           <div className="flex justify-between items-center mt-6">
//             <div></div>

//             <div className="w-64">
//               <CSVLink
//                 filename={
//                   activeTab === 'vendor list'
//                     ? 'vendor-list.csv'
//                     : 'customer-list.csv'
//                 }
//                 data={
//                   stats && activeTab === 'vendor list'
//                     ? stats?.data?.data?.affiliates
//                     : stats && activeTab === 'customer list'
//                     ? stats?.data?.data?.getCustomers
//                     : []
//                 }
//                 target="_blank"
//               >
//                 <Button
//                   label="Download CSV"
//                   className="btn-primary px-5 py-3 "
//                 />
//               </CSVLink>
//             </div>
//           </div>
//         </div>
//       </Card>
//     </section>
//   );
// };

// export default ViewStatsModal;
import Image from 'next/image';
import React, { useState, useMemo } from 'react';
import { CSVDownload, CSVLink } from 'react-csv';
import { useQuery } from 'react-query';
import { viewVendorStats } from '../../../../api-client/my-product';
import { deleteIcon, numberSales } from '../../../../assets/icons';
import { clicks, number, pending, totalSales, transfer } from '../../../../public/assets/icons';
import { capitalize } from '../../../../utils/formatters';
import Button from '../../../elements/button';
import Card from '../../../elements/card';
import TabGroup from '../../../elements/tab/tab-group';
import PageLoader from '../../page-loader';
import PriceQty from '../../price-qty-card';
import { PriceQtyCarouselQuo } from '../../price-qty-carousel';
import { CustomerListTable, VendorListTable } from './table';
import { toast } from 'react-toastify';

const ViewStatsModal = ({ setViewStats, productToken }) => {
  const [salesFilter, setSalesFilter] = useState('');
  const [monthFilter, setMonthFilter] = useState('');
  const [yearFilter, setYearFilter] = useState('');
  const [activeTab, setActiveTab] = useState('affiliate list');

  const {
    data: stats,
    isLoading,
    status,
  } = useQuery(['vendor-stats', productToken], () =>
    viewVendorStats({ productToken: Number(productToken) })
  );

  // Generate month and year options
  const monthOptions = [
    { value: '', label: 'All Months' },
    ...Array.from({ length: 12 }, (_, i) => ({
      value: (i + 1).toString().padStart(2, '0'),
      label: new Date(0, i).toLocaleString('default', { month: 'long' }),
    })),
  ];
  const yearOptions = [
    { value: '', label: 'All Years' },
    ...Array.from({ length: 5 }, (_, i) => {
      const year = new Date().getFullYear() - i;
      return { value: year.toString(), label: year.toString() };
    }),
  ];

  // Filter affiliates and customers
  const { filteredAffiliates, filteredCustomers, totalAffiliateSales, totalCustomerSales } = useMemo(() => {
    let affiliates = stats?.data?.data?.affiliates || [];
    let customers = stats?.data?.data?.getCustomers || [];
    let affiliateSales = 0;
    let customerSales = 0;

    if (monthFilter || yearFilter || salesFilter) {
      affiliates = affiliates.map((affiliate) => {
        let salesCount = affiliate.sales?.length || 0; // Assuming affiliate.sales is an array
        if (monthFilter || yearFilter) {
          const filteredSales = (affiliate.sales || []).filter((sale) => {
            const saleDate = new Date(sale.createdAt);
            const saleMonth = (saleDate.getMonth() + 1).toString().padStart(2, '0');
            const saleYear = saleDate.getFullYear().toString();
            return (
              (!monthFilter || saleMonth === monthFilter) &&
              (!yearFilter || saleYear === yearFilter)
            );
          });
          salesCount = filteredSales.length;
        }
        affiliateSales += salesCount;
        if (salesFilter && !salesCount.toString().includes(salesFilter)) {
          return null;
        }
        return { ...affiliate, count: salesCount };
      }).filter(Boolean);

      customers = customers.filter((customer) => {
        const saleDate = new Date(customer.createdAt);
        const saleMonth = (saleDate.getMonth() + 1).toString().padStart(2, '0');
        const saleYear = saleDate.getFullYear().toString();
        const matchesDate =
          (!monthFilter || saleMonth === monthFilter) &&
          (!yearFilter || saleYear === yearFilter);
        const matchesSales = !salesFilter || customer.price?.toString().includes(salesFilter);
        if (matchesDate && matchesSales) {
          customerSales += 1;
          return true;
        }
        return false;
      });
    } else {
      affiliateSales = affiliates.reduce((sum, aff) => sum + (aff.sales?.length || 0), 0);
      customerSales = customers.length;
    }

    return { filteredAffiliates: affiliates, filteredCustomers: customers, totalAffiliateSales, totalCustomerSales };
  }, [stats, salesFilter, monthFilter, yearFilter]);

  const sliderItems = useMemo(() => {
    return [
      {
        icon: clicks,
        price: status === 'error' ? 0 : stats?.data?.data?.salesSummary?.totalSales,
        title: 'Affiliate clicks',
      },
      {
        icon: numberSales,
        price:
          status === 'error'
            ? '$0'
            : `$${stats?.data?.data?.salesSummary?.totalAmountOfSales.toLocaleString()}`,
        title: 'Amount of Sales',
      },
      {
        icon: pending,
        price:
          status === 'error'
            ? '$0'
            : `$${stats?.data?.data?.salesSummary?.totalPendingPayment.toLocaleString()}`,
        title: 'Amount of Pending Sales',
      },
      {
        icon: number,
        price: status === 'error' ? 0 : stats?.data?.data?.salesSummary?.pageViews,
        title: 'Number of Page Views',
      },
      {
        icon: transfer,
        price:
          status === 'error'
            ? '0%'
            : `${stats?.data?.data?.salesSummary?.totalConversion}%`,
        title: 'Total Conversion',
      },
      {
        icon: totalSales,
        price:
          status === 'error'
            ? '$0'
            : `$${stats?.data?.data?.salesSummary.todaySales.toLocaleString()}`,
        title: 'Today Sales',
      },
    ];
  }, [stats]);

  const renderTable = (data) => {
    const totalSales = data === 'affiliate list' ? totalAffiliateSales : totalCustomerSales;
    return (
      <>
        <p className="text-sm font-medium mb-4">
          Total Sales: {totalSales.toLocaleString()}
        </p>
        {data === 'affiliate list' ? (
          filteredAffiliates.length === 0 ? (
            <div className="text-center py-4 text-gray-500">
              No affiliates match the current filters.
            </div>
          ) : (
            <VendorListTable stats={filteredAffiliates} />
          )
        ) : filteredCustomers.length === 0 ? (
          <div className="text-center py-4 text-gray-500">
            No customers match the current filters.
          </div>
        ) : (
          <CustomerListTable stats={filteredCustomers} />
        )}
      </>
    );
  };

  const handleSalesFilterChange = (e) => {
    const value = e.target.value;
    if (value && isNaN(value)) {
      toast.error('Please enter a valid number for sales filter');
      return;
    }
    setSalesFilter(value);
  };

  const handleClearFilters = () => {
    setSalesFilter('');
    setMonthFilter('');
    setYearFilter('');
    toast.success('Filters cleared');
  };

  return (
    <section className="h-full w-screen z-50 bg-black flex items-center justify-center fixed top-0 left-0 bg-opacity-40">
      <Card className="w-[1080px]">
        <div
          className="flex justify-end items-end mb-10"
          onClick={() => setViewStats(false)}
        >
          <button>
            <Image src={deleteIcon} alt="Close" />
          </button>
        </div>
        <h2 className="text-md font-medium">
          {stats && capitalize(stats?.data?.data?.salesSummary?.productName)}
        </h2>
        {status === 'error' ? (
          <div className="bg-info text-black px-6 w-full py-3">
            Sorry, this product has not been sold yet
          </div>
        ) : null}
        <div className="mt-4">
          <PriceQtyCarouselQuo data={sliderItems} />
        </div>
        <div className="hidden lg:grid grid-cols-3 gap-2 py-4 items-center">
          {isLoading ? (
            <>
              {[...Array(6)].map((_, i) => (
                <div key={i} className="animate-pulse h-48 rounded-2xl mb-2 w-64 my-2 bg-slate-100"></div>
              ))}
            </>
          ) : (
            <>
              <PriceQty
                price={status === 'error' ? 0 : stats?.data?.data?.salesSummary?.totalSales}
                shadow="shadow"
                icon={clicks}
                title="Total Number of Sales"
              />
              <PriceQty
                price={
                  status === 'error'
                    ? '$0'
                    : `$${stats?.data?.data?.salesSummary?.totalAmountOfSales.toLocaleString()}`
                }
                shadow="shadow"
                icon={numberSales}
                title="Amount of Sales"
              />
              <PriceQty
                price={
                  status === 'error'
                    ? '$0'
                    : `$${stats?.data?.data?.salesSummary?.totalPendingPayment.toLocaleString()}`
                }
                shadow="shadow"
                icon={pending}
                title="Amount of Pending Sales"
              />
              <PriceQty
                price={status === 'error' ? 0 : stats?.data?.data?.salesSummary?.pageViews}
                shadow="shadow"
                icon={number}
                title="Number of Page Views"
              />
              <PriceQty
                price={
                  status === 'error'
                    ? '0%'
                    : `${stats?.data?.data?.salesSummary?.totalConversion}%`
                }
                shadow="shadow"
                icon={transfer}
                title="Total Conversion"
              />
              <PriceQty
                price={
                  status === 'error'
                    ? '$0'
                    : `$${stats?.data?.data?.salesSummary.todaySales.toLocaleString()}`
                }
                shadow="shadow"
                icon={totalSales}
                title="Today Sales"
              />
            </>
          )}
        </div>

        <div className="grid grid-cols-2 items-center w-full mt-6">
          <div className="col-span-1">
            <TabGroup
              active={activeTab}
              setActive={setActiveTab}
              data={[
                { id: 1, name: 'Affiliate List' },
                { id: 2, name: 'Customer List' },
              ]}
            />
          </div>
          <div className="col-span-1 flex items-center gap-4 justify-end">
            <input
              type="text"
              placeholder="Filter by sales count..."
              value={salesFilter}
              onChange={handleSalesFilterChange}
              className="border border-gray-300 rounded px-3 py-2 w-full max-w-xs"
            />
            <select
              value={monthFilter}
              onChange={(e) => setMonthFilter(e.target.value)}
              className="border border-gray-300 rounded px-3 py-2 w-full max-w-xs"
            >
              {monthOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            <select
              value={yearFilter}
              onChange={(e) => setYearFilter(e.target.value)}
              className="border border-gray-300 rounded px-3 py-2 w-full max-w-xs"
            >
              {yearOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            <Button
              label="Clear Filters"
              className="bg-gray-200 text-black px-4 py-2"
              onClick={handleClearFilters}
            />
          </div>
        </div>
        {isLoading ? (
          <div className="flex items-center justify-center">
            <PageLoader
              loadingText="Loading Products, Please Wait... 😇"
              className="h-96 w-full"
            />
          </div>
        ) : (
          renderTable(activeTab)
        )}

        <div className="flex justify-between items-center mt-6">
          <div></div>
          <div className="w-64">
            <CSVLink
              filename={activeTab === 'affiliate list' ? 'vendor-list.csv' : 'customer-list.csv'}
              data={activeTab === 'affiliate list' ? filteredAffiliates : filteredCustomers}
              target="_blank"
            >
              <Button
                label="Download CSV"
                className="btn-primary px-5 py-3"
              />
            </CSVLink>
          </div>
        </div>
      </Card>
    </section>
  );
};

export default ViewStatsModal;